import React, { StatelessComponent} from 'react';
import cls from '../utils/classnames';
import { BUTTON, BUTTON_BLOCK } from '../utils/classes';
import Utils from '../../../../utils/Utils';
import './_styles.scss';

export type ButtonType = 'submit' | 'reset' | 'button';
export type ButtonVariant = 'info' | 'primary' | 'dark' | 'purple' | 'default' | 'gray';

/**
 * Button props.
 */
export interface IButtonProps {
    /**
     * The type property.
     * see https://www.w3.org/TR/2011/WD-html5-20110525/the-button-element.html#attr-button-type for more info.
     */
    type: ButtonType;
    /**
     * The button text.
     */
    children: React.ReactNode;
    /**
     * Type of button.,
     */
    variant?: ButtonVariant;
    /**
     * Makes the button occupy all available space in the container.
     */
    block?: boolean;
    /**
     * The elements id.
     */
    id?: string;
    /**
     * Additional class names to add-
     */
    className?: string;
    /**
     * disabled component property
     */
    disabled?: boolean;
    /**
     * callback to execute
     */
    onClick?: (event?: React.MouseEvent<HTMLElement>) => void;
    /**
     * callback to execute
     */
    onBlur?: () => void;
    /**
     * callback to execute
     */
    onFocus?: () => void;
    /**
     * callback to execute
     */
    onKeyDown?: (event?: React.KeyboardEvent<HTMLElement>) => void;
    /**
     * react css property object
     */
    style?: React.CSSProperties
    /**
     * activate scale transition
     */
    activate?: boolean;
    /**
     * show only in register
     */
    img?: string;
    dataOptions ?: object;
    //* Disabled transition focus left or right
    blockedLeft?: object;
    blockedRight?: object;
    /**
     * Para React 15 compatibility: pasa la ref como prop en lugar de ref attribute
     */
    innerRef?: (el: HTMLAnchorElement | null) => void;
}

/**
 * A button component.
 */
export const Button: StatelessComponent<IButtonProps> = ({
    id,
    block,
    type,
    disabled = false,
    children,
    variant,
    className,
    onClick,
    onBlur,
    onFocus,
    onKeyDown,
    style,
    activate,
    img,
    dataOptions = {},
    blockedLeft = {},
    blockedRight = {},
    innerRef,
}) => {
    id = id ? id : String(`keyP-${Math.floor(10000 + Math.random() * 90000)}`) 
    const classes = cls(
        BUTTON,
        `${BUTTON}-${variant}`,
        {
            [BUTTON_BLOCK]: block as boolean,
        },
        className,
        disabled ? 'disabled' : '',
        activate ? 'button-container': ''
    );

  const handleMouseEnter = (e: any) => {
    Utils.handleMouseEnter(e)
  }

  return (
    // La version legacy de Samsung no soporta onclick en el elemento button
    // se hace un fix cambiando el elemento
    <a
      id={id}
      className={classes}
      href="javascript:void(0)"
      tabIndex={0}
      onClick={onClick}
      onBlur={onBlur}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      style={style}
      onMouseEnter={() => handleMouseEnter(id)}
      {...dataOptions}
      {...blockedLeft}
      {...blockedRight}
      ref={innerRef}
    >
      {img !== undefined ? (<img className={cls(`${BUTTON}-img`)} src={img} alt={img} /> ) : ''}
      {children}
    </a>
  );
};

Button.displayName = 'Button';
Button.defaultProps = {
    block: false,
    variant: 'default'
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Button/index.tsx